import { v4 as uuid } from 'uuid';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
require('dayjs/locale/br');

export class VariableSchema {

    variable = null
    items = []

    constructor(items) {
        this.items = items
    }

    #findById(items, id) {

        for (const child of (items || [])) {
            if (child.id == id) {
                return child;
            }

            const search_response = this.#findById(child.items || [], id);
            if (search_response) {
                return search_response;
            }
        }

        return false;
    }

    findById(id) {
        return this.#findById(this.items, id);
    }

    #apply_value(items, id, value) {
        return items.map((child) => {
            child.items = this.#apply_value(child.items || [], id, value);
            if (child.id == id) {
                return (typeof value == 'function') ? value(child) : { ...child, ...(value || {}) };
            }
            return child;
        });
    }

    apply_value(id, value) {
        this.items = this.#apply_value(this.items, id, value)
        return this.items
    }

    #recursive(schema, fn) {
        fn(schema)
        schema.items?.forEach((i) => this.#recursive(i, fn));
    }

    recursive(fn) {
        this.#recursive(this, fn)
    }

    #deleteById(items, id) {
        const _items = [];

        for (const child of (items || [])) {
            if (child.id == id) {
                continue;
            }

            child.items = this.#deleteById(child.items || [], id);
            _items.push(child)
        }

        return _items;
    }

    deleteById(id) {
        this.items = this.#deleteById(this.items, id);
        return this.items;
    }

    /**
     * 
     * @param {Function} clear_fn Retornar true caso o item deva ser removido
     * @returns {Array<Array<Object>, Number>} Número de itens removidos
     */
    clear(clear_fn = null) {
        let count = 0, _count = 1;

        const custom_clear_fn = (c) => {
            if (clear_fn(c)) {
                count++;
                _count++;
                return false;
            }
            return true;
        };

        const default_clear_fn = (c) => {
            if (c.type != 'scope' || c.items?.length > 0) {
                return true;
            }
            count++;
            _count++;
            return false;
        };

        const fn = clear_fn ? custom_clear_fn : default_clear_fn;
        while (_count > 0) {
            _count = 0;
            this.recursive((child) => { child.items = child.items.filter(c => fn(c)); });
        }

        return [this.items, count];
    }

    static constructEmptyScope(data = {}) {
        return {
            id: uuid(),
            type: 'scope',
            operand: 'and',
            items: [],
            ...(data || {})
        };
    }

    static constructEmptyClause(type, data = {}) {
        return {
            id: uuid(),
            type: type,
            operand: 'eq',
            value: null,
            range: {
                type: null,
                period: null,
                min: null,
                max: null,
            },
            ...(data || {})
        };
    }

    static validateRange(range) {
        const { type, period, min, max } = range || {};
        switch (type) {
            case 'in_last':
                return Number(min) > 0 && !!period;
            case 'eq':
            case 'neq':
                return dayjs(min, "DD/MM/YYYY", 'br', true).isValid();
            case 'range':
                const min_date = dayjs(min, "DD/MM/YYYY", 'br', true);
                const max_date = dayjs(max, "DD/MM/YYYY", 'br', true);
                return min_date.isValid() && max_date.isValid() && (min_date.isBefore(max_date) || min_date.isSame(max_date));
            default:
                return true;
        }
    }

    static countValidClauses(data) {
        if (data.items?.length > 0) {
            return data.items.reduce((t, c) => t + VariableSchema.countValidClauses(c), 0)
        } 
        return (data.type != 'scope' && !data.hide) ? 1 : 0;
    }

}